import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { IAnimal } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetAnimalById(animalId: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<IAnimal, Error>({
    queryKey: ['getAnimalById', farmId, animalId],
    queryFn: () => animalController.getAnimalById(farmId!, animalId),
    enabled: !!farmId && !!animalId
  })
}
